import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from 'store/hooks/useStore';

import * as releaseApi from 'api/releaseApi';
import { useToast } from 'hooks/useToast';
import { loaderActions } from 'store/reducers/loaderReducer/loaderSlice';
import {
  editActions,
  editSelectors,
} from 'store/reducers/releaseReducers/releaseComponentReducer/editSlice';
import { useListStore } from './useListStore';

export const useDeleteStore = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const { fetchReleaseComponents } = useListStore();
  const selectedReleaseComponent = useAppSelector(
    editSelectors.selectedReleaseComponent,
  );
  const isOpenModal = useAppSelector(editSelectors.isOpenModalDelete);

  const onCloseModal = useCallback(() => {
    dispatch(editActions.updateIsOpenModalDelete(false));
  }, [dispatch]);

  const onDeleteComponent = useCallback(() => {
    if (selectedReleaseComponent) {
      const componentId = selectedReleaseComponent.id
        ? selectedReleaseComponent.id
        : 0;
      const requestDelete = async () => {
        dispatch(loaderActions.setLoading(true));
        dispatch(editActions.updateLoadingStatus(true));
        const result = await releaseApi.deleteComponent(componentId);
        if (result.ok) {
          toast({
            status: 'success',
            description: `コンポーネントを削除しました。`,
          });

          onCloseModal();
          dispatch(editActions.modalOpened(null));
          void fetchReleaseComponents();
        } else {
          toast({
            status: 'error',
            description: `コンポーネントの削除に失敗しました。`,
          });
        }
        dispatch(editActions.updateLoadingStatus(false));
        dispatch(loaderActions.setLoading(false));
      };

      requestDelete().catch(() => {
        toast({
          status: 'error',
          description: `コンポーネントの削除に失敗しました。`,
        });
      });
    }
  }, [
    selectedReleaseComponent,
    toast,
    dispatch,
    onCloseModal,
    fetchReleaseComponents,
  ]);

  return {
    /** コンポーネントの内容 */
    values: selectedReleaseComponent || {
      componentName: '',
      repositoryUrl: '',
      manifestName: '',
      targetKeys: [{ value: '' }],
    },
    /** コンポーネントの削除 */
    onDeleteComponent,
    /** コンポーネントの削除キャンセル */
    onCloseModal,
    /** コンポーネント削除確認モーダルの表示状態 */
    isOpenModal,
  };
};
